var map = {
	"./en/adminAccount.json": 94901,
	"./es/adminAccount.json": 1646,
	"./fr/adminAccount.json": 99855,
	"./it/adminAccount.json": 47205,
	"./pt-BR/adminAccount.json": 48712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95656;